import { DB_NAME } from '@tencent/ark-model';
import LoggerPlugin from '@tencent/memoire-plugin-logger';
import StructuredStorage from '@tencent/memoire-structured-storage';
export { SortOrder } from '@tencent/memoire-structured-storage';
import MonitorPlugin from '@tencent/memoire-plugin-monitor';
import IDBEngine from '@tencent/memoire-idb-engine';
import NativeEngine from '@tencent/memoire-native-engine';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

var DATABASE_SCHEMA = '{"name":"unknown","collections":[{"name":"DocumentData","key":{"path":"key"},"indices":[{"name":"secretId","path":"secretId","unique":false},{"name":"globalPadId","path":"globalPadId","unique":false},{"name":"version","path":"version","unique":false},{"name":"type","path":"type","unique":false},{"name":"uid","path":"uid","unique":false},{"name":"subId","path":"subSheetId","unique":false},{"name":"chunkId","path":"chunkId","unique":false}],"properties":["key","secretId","globalPadId","version","type","uid","subId","chunkId","taskId","data","docType","docStatus","createTimestamp","lastModifyTimestamp","dataVersion","isDefaultChunk","subGlobalPadId","subDocType"]},{"name":"DocumentEntities","key":{"path":"key"},"indices":[],"properties":["key","data"]},{"name":"NewDocumentIds","key":{"path":"globalPadId"},"indices":[],"properties":["globalPadId","secretId","documentType","localPadId","isCreated"]},{"name":"DocumentStatus","key":{"path":"globalPadId"},"indices":[{"name":"secretId","path":"secretId","unique":false},{"name":"uid","path":"uid","unique":false}],"properties":["globalPadId","secretId","uid","lastSyncTimestamp","lastErrorTimestamp"]},{"name":"OfflineData","key":{"path":"key"},"indices":[{"name":"secretId","path":"secretId","unique":false},{"name":"globalPadId","path":"globalPadId","unique":false},{"name":"version","path":"version","unique":false},{"name":"type","path":"type","unique":false},{"name":"uid","path":"uid","unique":false},{"name":"subId","path":"subSheetId","unique":false},{"name":"chunkId","path":"chunkId","unique":false}],"properties":["key","secretId","globalPadId","version","type","uid","subId","chunkId","taskId","data","docType","docStatus","createTimestamp","lastModifyTimestamp","dataVersion","isDefaultChunk","subGlobalPadId","subDocType"]},{"name":"PadInfo","key":{"path":"key"},"indices":[{"name":"secretId","path":"secretId","unique":false},{"name":"globalPadId","path":"globalPadId","unique":false},{"name":"uid","path":"uid","unique":false}],"properties":["key","secretId","globalPadId","uid","addListTimestamp","attribute","childrenLength","clientVersion","createTimestamp","creator","creatorDomain","icon","docPolicy","docPrivilege","thumbnail","docType","docTypeDesc","url","domainId","dver","folder","folderId","folderPolicy","folderPrivilege","isDeleted","isManualOffline","isMyCreated","isMydoc","isOfflineCache","isRencent","isShareToMe","hasSnapShot","isStar","isAddedToMy","isCollected","isOwner","isPinned","isShortcut","isUserChangeTitle","lastSyncTimestamp","lastBrowseTimestamp","lastCollectTimestamp","lastDeleteTimestamp","lastModifyTimestamp","lastModifyNick","lastModifyUid","lastPinnedTimestamp","listInfoType","listType","offlineCommiting","offlineCommitSuccessd","originFolderId","ownerNick","ownerUid","padId","parentFolderId","parents","privilege","status","title","type","hasLocalChanges","docSubType","officialAuthInfo","personalizeInfo","nativeEngineStatusRecord","nativeEngineDocPrivilege","data","ext","isOfflineCacheByNative","mimeType","ownerVipInfo"]},{"name":"Users","key":{"path":"key"},"indices":[{"name":"tinyId","path":"tinyId","unique":false},{"name":"nowUserIndex","path":"nowUserIndex","unique":false},{"name":"docId","path":"docId","unique":false},{"name":"pageType","path":"pageType","unique":false},{"name":"wedriveUin","path":"wedriveUin","unique":false},{"name":"wedocOpenId","path":"wedocOpenId","unique":false}],"properties":["key","tinyId","nowUserIndex","docId","pageType","wedriveUin","wedocOpenId","corpId","corpName","englishName","loginType","openId","uidSource","uin","userId","userName","userPic","updateTime","settings","bindUserInfo","vipUserInfo"]}]}';

var STORAGE_MONITOR_EVENT = 'storageActionResultAndCost';
function getMonitorPlugin(monitorReporter) {
  var plugin = new MonitorPlugin({
    onEvent: function onEvent(event) {
      monitorReporter.report(STORAGE_MONITOR_EVENT, {
        action: event.action,
        module: event.module,
        retCode: event.actionExecuteState,
        cost: event.cost,
        time: event.time.getTime(),
        errorMsg: event.errorMsg
      });
    }
  });
  return plugin;
}

var _a;
/**
 * 数据库的当前版本
 */

var databaseVersion = 4;
/**
 * 数据库初始化默认超时
 */

var defaultTimeout = 15 * 1000;
var DBEngineType;

(function (DBEngineType) {
  DBEngineType[DBEngineType["indexDB"] = 1] = "indexDB";
  DBEngineType[DBEngineType["nativeDB"] = 2] = "nativeDB";
})(DBEngineType || (DBEngineType = {}));

var dbEngineGenerator = (_a = {}, _a[DBEngineType.indexDB] = IDBEngine, _a[DBEngineType.nativeDB] = NativeEngine, _a);

var StorageManager =
/** @class */
function () {
  function StorageManager(config) {
    if (config === void 0) {
      config = {
        type: DBEngineType.indexDB,
        disableAutoOpen: true
      };
    }

    var _a;

    this.config = config;
    var DBEngineGenerator = dbEngineGenerator[config.type];
    this.storage = new StructuredStorage({
      name: (_a = config.databaseName) !== null && _a !== void 0 ? _a : DB_NAME,
      version: databaseVersion,
      engine: new DBEngineGenerator(),
      databaseSchema: DATABASE_SCHEMA,
      disableAutoOpen: config.disableAutoOpen,
      plugins: this.getPlugins(config),
      supportCompatibleOpen: true
    });
  }

  StorageManager.prototype.dispose = function () {
    this.storage.close();
  };

  StorageManager.prototype.init = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        return [2
        /*return*/
        , new Promise(function (resolve) {
          var _a; // 超时未完成初始化


          var timeoutId = setTimeout(function () {
            var _a, _b;

            (_b = (_a = _this.config.logger) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, 'dababase init timeout.');
            resolve(false);
          }, (_a = _this.config.timeout) !== null && _a !== void 0 ? _a : defaultTimeout);

          _this.storage.open().then(function () {
            resolve(true);
            clearTimeout(timeoutId);
          }).catch(function () {
            resolve(false);
            clearTimeout(timeoutId);
          });
        })];
      });
    });
  };

  StorageManager.prototype.getPlugins = function (config) {
    var plugins = [];

    if (config.logger) {
      var logger = new LoggerPlugin({
        logger: config.logger,
        disabled: !!config.disabled,
        verbose: !!config.verbose
      });
      plugins.push(logger);
    }

    if (config.monitorReporter) {
      plugins.push(getMonitorPlugin(config.monitorReporter));
    }

    return plugins;
  };

  return StorageManager;
}();

var DB_NAME_BACKUP = 'TencentDocsBackup';

var StorageBackupManager =
/** @class */
function (_super) {
  __extends(StorageBackupManager, _super);

  function StorageBackupManager(config) {
    if (config === void 0) {
      config = {
        type: DBEngineType.indexDB,
        disableAutoOpen: true
      };
    }

    var _this = _super.call(this, config) || this;

    _this.config = config;
    return _this;
  }

  return StorageBackupManager;
}(StorageManager);

var ChangeStorage =
/** @class */
function () {
  function ChangeStorage(collection) {
    this.collection = collection;
  }

  ChangeStorage.prototype.getChanges = function (storageOption, queryOption) {
    return __awaiter(this, void 0, void 0, function () {
      var query;
      return __generator(this, function (_a) {
        query = this.collection.where({
          uid: storageOption.uid,
          secretId: storageOption.secretId,
          subGlobalPadId: storageOption.subGlobalPadId,
          type: {
            in: storageOption.types
          },
          docType: storageOption.docType,
          dataVersion: storageOption.dataVersion,
          subId: {
            in: storageOption.subId ? new Array().concat(storageOption.subId) : undefined
          },
          chunkId: {
            in: storageOption.chunkId ? new Array().concat(storageOption.chunkId) : undefined
          },
          version: {
            '>=': queryOption === null || queryOption === void 0 ? void 0 : queryOption.startVersion,
            '<=': queryOption === null || queryOption === void 0 ? void 0 : queryOption.endVersion
          }
        });

        if (queryOption === null || queryOption === void 0 ? void 0 : queryOption.orderPath) {
          query.orderBy(queryOption.orderPath, queryOption.sortOrder);
        }

        if (queryOption === null || queryOption === void 0 ? void 0 : queryOption.limit) {
          query.take(queryOption.limit);
        }

        return [2
        /*return*/
        , query.values()];
      });
    });
  };

  ChangeStorage.prototype.upsertChanges = function (changes) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.bulkUpsert(changes)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ChangeStorage.prototype.deleteChanges = function (option) {
    return __awaiter(this, void 0, void 0, function () {
      var uid, secretId, globalPadId, types, taskIds, subGlobalPadId;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            uid = option.uid, secretId = option.secretId, globalPadId = option.globalPadId, types = option.types, taskIds = option.taskIds, subGlobalPadId = option.subGlobalPadId;
            return [4
            /*yield*/
            , this.collection.where({
              uid: uid,
              secretId: secretId,
              globalPadId: globalPadId,
              subGlobalPadId: subGlobalPadId,
              type: {
                in: types
              },
              taskId: {
                in: taskIds
              },
              version: {
                '>': option.startVersion || Number.MIN_SAFE_INTEGER,
                '<': option.endVersion || Number.MAX_SAFE_INTEGER
              }
            }).clear()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return ChangeStorage;
}();

var DocumentDataStorage =
/** @class */
function (_super) {
  __extends(DocumentDataStorage, _super);

  function DocumentDataStorage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return DocumentDataStorage;
}(ChangeStorage);

var OfflineDataStorage =
/** @class */
function (_super) {
  __extends(OfflineDataStorage, _super);

  function OfflineDataStorage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return OfflineDataStorage;
}(ChangeStorage);

/**
 * 预拉取的文档 ID 表相关存取接口
 * 注意：所有数据库操作都可能面临异常情况
 * 与 bingo 确认后，确定将错误直接抛出到外层，由外层统一处理
 */

var DocumentIdStorage =
/** @class */
function () {
  function DocumentIdStorage(collection) {
    this.collection = collection;
  }
  /**
   * 取出一个有效的 DoumentId，同时将从数据库中删除该条记录
   * @return DocumentId 对象，如果没有记录则返回 null
   */


  DocumentIdStorage.prototype.popDocumentId = function (documentType) {
    return __awaiter(this, void 0, void 0, function () {
      var documentIdModelValue, key, deleteKey;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.where({
              documentType: documentType
            }).first()];

          case 1:
            documentIdModelValue = _a.sent(); // 如果没有的话

            if (!documentIdModelValue) return [2
            /*return*/
            , null];
            key = documentIdModelValue.globalPadId;
            return [4
            /*yield*/
            , this.collection.delete(key)];

          case 2:
            deleteKey = _a.sent();

            if (key !== deleteKey) {
              return [2
              /*return*/
              , null];
            }

            return [2
            /*return*/
            , documentIdModelValue];
        }
      });
    });
  };
  /**
   * 插入多个 DocumentId 记录，如果记录不存在则会插入新纪录
   * @param ids DocumentId 对象数组
   */


  DocumentIdStorage.prototype.upsertDocumentIds = function (ids) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.bulkUpsert(ids)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 查询所有 DocumentId 记录
   */


  DocumentIdStorage.prototype.countDocumentIds = function (documentType) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , this.collection.where({
          documentType: documentType
        }).count()];
      });
    });
  };
  /**
   * 删除所有的DocumentId对象
   */


  DocumentIdStorage.prototype.deleteDocumentIds = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.clear()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return DocumentIdStorage;
}();

var DocumentStatusStorage =
/** @class */
function () {
  function DocumentStatusStorage(collection) {
    this.collection = collection;
  }
  /**
   * 查询指定用户指定文档的同步状态记录
   */


  DocumentStatusStorage.prototype.getStatus = function (uid, secretId) {
    return __awaiter(this, void 0, void 0, function () {
      var entity;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.where({
              secretId: secretId,
              uid: uid
            }).first()];

          case 1:
            entity = _a.sent();
            return [2
            /*return*/
            , entity];
        }
      });
    });
  };
  /**
   * 更新同步状态记录
   */


  DocumentStatusStorage.prototype.upsertStatus = function (status) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            // 更新文档
            return [4
            /*yield*/
            , this.collection.upsert(status)];

          case 1:
            // 更新文档
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 删除指定用户指定文档的同步状态记录
   */


  DocumentStatusStorage.prototype.deleteStatus = function (uid, secretId) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            // 删除文档信息
            return [4
            /*yield*/
            , this.collection.where({
              secretId: secretId,
              uid: uid
            }).clear()];

          case 1:
            // 删除文档信息
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return DocumentStatusStorage;
}();

var DocumentEntityStorage =
/** @class */
function () {
  function DocumentEntityStorage(collection) {
    this.collection = collection;
  }
  /**
   * 查询指定扩展数据实体
   *
   * @template T
   * @param {string} key 查询的扩展数据实体key
   * @return {*}  {(Promise<DocumentEntity<T> | null>)}
   * @memberof DocumentEntityStorage
   */


  DocumentEntityStorage.prototype.getEntity = function (key) {
    return __awaiter(this, void 0, void 0, function () {
      var entity;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.get(key)];

          case 1:
            entity = _a.sent();
            return [2
            /*return*/
            , entity];
        }
      });
    });
  };
  /**
   * 批量更新扩展实体
   *
   * @template T
   * @param {DocumentEntity<T>[]} entities
   * @return {*}  {Promise<void>}
   * @memberof DocumentEntityStorage
   */


  DocumentEntityStorage.prototype.upsertEntities = function (entities) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.bulkUpsert(entities)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 删除指定key的扩展数据实体
   *
   * @param {string} key 要删除的扩展数据实体key
   * @return {*}  {Promise<void>}
   * @memberof DocumentEntityStorage
   */


  DocumentEntityStorage.prototype.deleteEntity = function (key) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.delete(key)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return DocumentEntityStorage;
}();

/**
 * 文档基础信息表 PadInfo 基础操作 API 封装
 */

var PadInfoStorage =
/** @class */
function () {
  function PadInfoStorage(collection) {
    this.collection = collection;
  }
  /**
   * 根据指定ID查询文档PadInfo信息
   * @param secretId 文档加密 id
   * @param uid 用户 id
   */


  PadInfoStorage.prototype.getPadInfo = function (uid, secretId) {
    return __awaiter(this, void 0, void 0, function () {
      var padInfos;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.getPadInfos({
              uid: uid,
              secretId: secretId
            })];

          case 1:
            padInfos = _a.sent();
            if (padInfos.length === 0) return [2
            /*return*/
            , null];
            return [2
            /*return*/
            , padInfos.shift()];
        }
      });
    });
  };
  /**
   * 查询符合指定条件的文档PadInfo信息
   * @param queryOption 查询条件
   */


  PadInfoStorage.prototype.getPadInfos = function (queryOption) {
    return __awaiter(this, void 0, void 0, function () {
      var query;
      return __generator(this, function (_a) {
        query = this.collection.where({
          uid: queryOption.uid,
          secretId: {
            in: queryOption.secretId ? new Array().concat(queryOption.secretId) : undefined
          }
        });
        return [2
        /*return*/
        , query.values()];
      });
    });
  };
  /**
   * 更新文档PadInfo信息（全量更新接口）
   * @param padinfo 文档PadInfo信息
   */


  PadInfoStorage.prototype.upsertPadInfo = function (padInfo) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.upsert(padInfo)];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 更新PadInfo指定字段值
   * @param secretId 文档加密 id
   * @param uid 用户id
   * @param deltaFields 待更新的字段和值
   */


  PadInfoStorage.prototype.updateField = function (uid, secretId, deltaFields) {
    return __awaiter(this, void 0, void 0, function () {
      var padInfo;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.where({
              uid: uid,
              secretId: secretId
            }).first()];

          case 1:
            padInfo = _a.sent();
            if (!padInfo) return [2
            /*return*/
            ];
            Object.assign(padInfo, deltaFields);
            return [4
            /*yield*/
            , this.collection.upsert(padInfo)];

          case 2:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * 删除指定文档的PadInfo信息
   * @param secretId 文档加密 id
   * @param uid 用户id
   */


  PadInfoStorage.prototype.deletePadInfo = function (uid, secretId) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.where({
              uid: uid,
              secretId: secretId
            }).clear()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return PadInfoStorage;
}();

var UserInfoStorage =
/** @class */
function () {
  function UserInfoStorage(collection) {
    this.collection = collection;
  }

  UserInfoStorage.prototype.getUserInfoByNowUserIndex = function (nowUserIndex) {
    return __awaiter(this, void 0, void 0, function () {
      var userInfo;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.where({
              nowUserIndex: nowUserIndex
            }).last()];

          case 1:
            userInfo = _a.sent();

            if (userInfo) {
              return [2
              /*return*/
              , userInfo];
            }

            return [4
            /*yield*/
            , this.getUserInfoLastByAll()];

          case 2:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  UserInfoStorage.prototype.getUserInfoByDocInfo = function (pageType, docId) {
    return __awaiter(this, void 0, void 0, function () {
      var userInfo;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.where({
              pageType: pageType,
              docId: docId
            }).last()];

          case 1:
            userInfo = _a.sent();

            if (userInfo) {
              return [2
              /*return*/
              , userInfo];
            }

            return [4
            /*yield*/
            , this.getUserInfoLastByAll()];

          case 2:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  UserInfoStorage.prototype.addUserInfo = function (data) {
    return __awaiter(this, void 0, void 0, function () {
      var user;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , this.collection.get(data.key)];

          case 1:
            user = _a.sent();
            this.collection.upsert(_assign(_assign({}, user), data));
            return [2
            /*return*/
            , true];

          case 2:
            _a.sent();
            return [2
            /*return*/
            , false];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  UserInfoStorage.prototype.updateUserInfo = function (param, deltaFields) {
    return __awaiter(this, void 0, void 0, function () {
      var userList, upsertList;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 3,, 4]);

            return [4
            /*yield*/
            , this.collection.where(param).values()];

          case 1:
            userList = _b.sent();

            if (!userList.length) {
              return [2
              /*return*/
              , false];
            }

            upsertList = userList.map(function (item) {
              return _assign(_assign({}, item), deltaFields);
            });
            return [4
            /*yield*/
            , this.collection.bulkUpsert(upsertList)];

          case 2:
            _b.sent();

            return [2
            /*return*/
            , true];

          case 3:
            _b.sent();
            return [2
            /*return*/
            , false];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  UserInfoStorage.prototype.getUserInfoLastByAll = function () {
    return __awaiter(this, void 0, void 0, function () {
      var userInfo;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.collection.last()];

          case 1:
            userInfo = _a.sent();
            return [2
            /*return*/
            , userInfo];
        }
      });
    });
  };

  return UserInfoStorage;
}();

export { DBEngineType, DB_NAME_BACKUP, DocumentDataStorage, DocumentEntityStorage, DocumentIdStorage, DocumentStatusStorage, OfflineDataStorage, PadInfoStorage, StorageBackupManager, StorageManager, UserInfoStorage };
//# sourceMappingURL=index.js.map
